module.exports = ".loading--section--container {\n  height: 200px;\n  padding: 50px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/regimen-fiscal/add-modal/add-modal.component.scss
// module id = ./src/app/pages/regimen-fiscal/add-modal/add-modal.component.scss
// module chunks = main